import React, { useState } from 'react'
import DashboardNavbar from '../dashboardNav/DashboardNavbar'
import DashboardSideBar from '../dashboardNav/DashboardSidebar'
import './style.scss'

const Wrapper = (props) => {
    const [showSidebar, setShowSidebar] = useState(false)
    // let userdata = JSON.parse(localStorage.getItem("user"))

    const show_sidebar = () => {
        setShowSidebar(!showSidebar)
    }

    return (
        <>
            <span onClick={show_sidebar} className='show_sidebar'>
                {showSidebar ? 
                    <i className='fa fa-times'></i>
                :
                    <i className='fa fa-bars'></i>
                }
                
            </span>
            <DashboardNavbar />
            <div className='dashboard-wrapper'>
                <DashboardSideBar style={showSidebar ? "dashboard_sidebar res_show_sidebar" : "dashboard_sidebar res_hide_sidebar"} />
                <div className='dashboard_container'>
                    <div className="main_dash_content">
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Wrapper
